
import React from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import InputMask from "react-input-mask";

type Eatery = {
  name: string;
  type: string;
};

interface WaitlistFormProps {
  name: string;
  setName: (name: string) => void;
  email: string;
  setEmail: (email: string) => void;
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  selectedEatery: string;
  setSelectedEatery: (eatery: string) => void;
  preference: string;
  setPreference: (preference: string) => void;
  contactMethod: string;
  setContactMethod: (method: string) => void;
  eateries?: Eatery[];
  isEateryRequest: boolean;
  isRequestEatery: boolean;
  isFromPreOrder: boolean;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
}

export function WaitlistForm({
  name,
  setName,
  email,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  selectedEatery,
  setSelectedEatery,
  preference,
  setPreference,
  contactMethod,
  setContactMethod,
  eateries,
  isEateryRequest,
  isRequestEatery,
  isFromPreOrder,
  handleSubmit
}: WaitlistFormProps) {
  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-white">
      <div className="space-y-2">
        <label htmlFor="name" className="text-sm font-medium">
          Name
        </label>
        <Input 
          id="name" 
          value={name} 
          onChange={e => setName(e.target.value)} 
          required 
          placeholder="Enter your name" 
          className="bg-white text-base" 
          style={{ fontSize: "16px" }} 
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="email" className="text-sm font-medium">
          Email
        </label>
        <Input 
          id="email" 
          type="email" 
          value={email} 
          onChange={e => setEmail(e.target.value)} 
          required 
          placeholder="Enter your email" 
          className="bg-white text-base" 
          style={{ fontSize: "16px" }} 
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="phone" className="text-sm font-medium">
          Phone Number
        </label>
        <InputMask mask="(999) 999 9999" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)}>
          {(inputProps: any) => (
            <Input
              {...inputProps}
              id="phone"
              type="tel"
              inputMode="tel"
              required
              placeholder="(123) 456 7890"
              className="bg-white text-base"
              style={{ fontSize: "16px" }}
            />
          )}
        </InputMask>
      </div>
      <div className="space-y-2">
        <label htmlFor="eatery" className="text-sm font-medium">
          Eatery
        </label>
        {isRequestEatery && !isFromPreOrder ? (
          <Input 
            id="eatery" 
            value={selectedEatery} 
            onChange={e => setSelectedEatery(e.target.value)} 
            required 
            placeholder="Enter the eatery name" 
            className="bg-white text-base" 
            style={{ fontSize: "16px" }} 
          />
        ) : (
          <Select value={selectedEatery} onValueChange={setSelectedEatery} required>
            <SelectTrigger className="w-full bg-white border border-input">
              <SelectValue placeholder="Select an eatery" />
            </SelectTrigger>
            <SelectContent className="bg-white border shadow-lg" position="popper" sideOffset={5}>
              {eateries?.map(eatery => (
                <SelectItem key={eatery.name} value={eatery.name} className="focus:bg-gray-100 cursor-pointer">
                  {eatery.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
      {!isEateryRequest && (
        <>
          <div className="space-y-2">
            <label className="text-sm font-medium">Contact Me By:</label>
            <ToggleGroup type="single" value={contactMethod} onValueChange={value => {
              if (value) setContactMethod(value);
            }} className="flex justify-center w-full border border-input rounded-md p-1 bg-white">
              <ToggleGroupItem value="phone" className={`flex-1 text-center rounded-md py-1.5 ${contactMethod === 'phone' ? 'bg-[#4A90E2] text-white' : 'hover:bg-gray-100'}`}>
                Phone
              </ToggleGroupItem>
              <ToggleGroupItem value="email" className={`flex-1 text-center rounded-md py-1.5 ${contactMethod === 'email' ? 'bg-[#4A90E2] text-white' : 'hover:bg-gray-100'}`}>
                Email
              </ToggleGroupItem>
            </ToggleGroup>
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium">Boost Card Preference</label>
            <ToggleGroup type="single" value={preference} onValueChange={value => {
              if (value) setPreference(value);
            }} className="flex justify-center w-full border border-input rounded-md p-1 bg-white">
              <ToggleGroupItem value="physical" className={`flex-1 text-center rounded-md py-1.5 ${preference === 'physical' ? 'bg-[#4A90E2] text-white' : 'hover:bg-gray-100'}`}>
                Physical
              </ToggleGroupItem>
              <ToggleGroupItem value="digital" className={`flex-1 text-center rounded-md py-1.5 ${preference === 'digital' ? 'bg-[#4A90E2] text-white' : 'hover:bg-gray-100'}`}>
                Digital
              </ToggleGroupItem>
            </ToggleGroup>
          </div>
        </>
      )}
      <Button type="submit" className="w-full bg-eatsboost-orange hover:bg-eatsboost-orange/90 text-white">
        Send
      </Button>
    </form>
  );
}
